import * as THREE from 'three';

import PointCloud from './PointCloud.js';


export default class SphereAnimation {

    constructor(containerId = 'animation-canvas') {

        this.containerId = containerId;

        this.container = null;

        this.scene = null;
        this.camera = null;
        this.renderer = null;

        this.pointCloud = null;

        this.running = false;

        this.animationFrame = null;

        this.animate = this.animate.bind(this);
        this.onResize = this.onResize.bind(this);

    }


    init() {

        this.container =
            document.getElementById(this.containerId);

        if (!this.container) {

            console.error(
                `Container "${this.containerId}" not found.`
            );

            return;

        }


        this.container.innerHTML = '';


        /* SCENA */

        this.scene = new THREE.Scene();

        this.scene.background =
            new THREE.Color(0x030712);

        this.scene.fog =
            new THREE.Fog(
                0x030712,
                3,
                9
            );


        /* KAMERA */

        this.camera =
            new THREE.PerspectiveCamera(
                60,
                window.innerWidth / window.innerHeight,
                0.1,
                1000
            );

        this.camera.position.z = 5;


        /* RENDERER */

        this.renderer =
            new THREE.WebGLRenderer({
                antialias: true
            });

        this.renderer.setPixelRatio(
            window.devicePixelRatio
        );

        this.renderer.setSize(
            window.innerWidth,
            window.innerHeight
        );

        this.container.appendChild(
            this.renderer.domElement
        );


        /* CHMURA PUNKTÓW */

        this.pointCloud =
            new PointCloud();

        this.scene.add(
            this.pointCloud.object
        );


        /* EVENTY */

        window.addEventListener(
            'resize',
            this.onResize
        );


        /* START */

        this.running = true;

        this.animate();

    }


    animate() {

        if (!this.running) {
            return;
        }

        this.animationFrame =
            requestAnimationFrame(
                this.animate
            );


        const time =
            performance.now() * 0.001;


        /* RUCH KAMERY */

        this.camera.position.x =
            Math.sin(time * 0.25) * 5;

        this.camera.position.z =
            Math.cos(time * 0.25) * 5;

        this.camera.position.y =
            Math.sin(time * 0.5) * 0.4;

        this.camera.lookAt(
            0,
            0,
            0
        );


        /* OBRÓT CHMURY */

        this.pointCloud.update(
            0.016
        );


        /* RENDER */

        this.renderer.render(
            this.scene,
            this.camera
        );

    }


    onResize() {

        this.camera.aspect =
            window.innerWidth /
            window.innerHeight;

        this.camera.updateProjectionMatrix();

        this.renderer.setSize(
            window.innerWidth,
            window.innerHeight
        );

    }


    dispose() {

        this.running = false;


        if (this.animationFrame) {

            cancelAnimationFrame(
                this.animationFrame
            );

        }


        window.removeEventListener(
            'resize',
            this.onResize
        );


        if (this.pointCloud) {

            this.pointCloud.object.geometry.dispose();

            this.pointCloud.object.material.dispose();

        }


        if (this.renderer) {

            this.renderer.dispose();

            if (
                this.renderer.domElement.parentNode
            ) {

                this.renderer.domElement
                    .parentNode
                    .removeChild(
                        this.renderer.domElement
                    );

            }

        }

    }

}
